//=====================================================
//　G020：キャンセル確定
//=====================================================

import { useHistory } from "react-router-dom";
import { ContentsBox } from "../../common/ContentsBox";
import { BtnSubmit } from "../../common/BtnSubmit";
import { ContentsTitle } from "../../common/ContentsTitle";
import { ReservationInfo } from "../../common/ReservationInfo";
import { useContext, useEffect } from "react";
import { CtxClinicInfo } from "../../utils/Contexts";

export function G020(){

    const history = useHistory();
    const cci = useContext(CtxClinicInfo);

    // タイトル追加処理
    useEffect(function(){
        if(cci.data.name){
            document.title = cci.data.name + " | Web予約 - キャンセル確定";
        }else{
            document.title = process.env.REACT_APP_DEFAULT_CLININC_NAME + " | Web予約 - キャンセル確定";
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <ContentsBox>
                <ContentsTitle title="以下のご予約のキャンセルが完了しました" />
                <ReservationInfo />
                <BtnSubmit title="Web予約マイページへ" onClick={function(){history.push("/mypage")}} />
            </ContentsBox>
        </>
    );

}